module.exports = __webpack_public_path__ + "static/media/icon_confirmation.2a6dcf7c.svg";